import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pb-20 md:pb-0" }

import MainNav from "./components/MainNav.vue";
import BottomNav from "./components/BottomNav.vue";
import ToastProvider from "./components/common/ToastProvider.vue";
import { useAuthStore } from "./stores/auth";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const auth = useAuthStore();
auth.verify_status();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainNav),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(BottomNav),
    _createVNode(ToastProvider)
  ], 64))
}
}

})